module.exports = __webpack_public_path__ + "static/media/HowtoBestPrepareforSurgery.71f6f90e.pdf";